import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { withFormik, FormikProps } from 'formik';
import { Grid, Box } from '@material-ui/core';
import { DropzoneAreaBase } from 'material-ui-dropzone';

import { translate } from 'helpers/intl';
import ActionsButtons from 'containers/SignupPages/ActionsButtons';
import { AssuranceIcon } from 'images';
import get from 'lodash/get';
import formatBytes from 'utils/formatBytes';
import {
  StyledDropZoneContainer,
  ImageWrapper,
  StyledShortBody,
  StyledCaptions,
} from 'containers/SignupPages/VerifyIdentity/styles';
import messages from 'containers/SignupPages/VerifyIdentity/messages';
const InnerForm = (props: FormProps & FormikProps<FormValues>) => {
  const {
    values,
    handleSubmit,
    isLoading,
    onClickPrevious,
    setFieldValue,
  } = props;

  /* istanbul ignore next */
  return (
    <form onSubmit={handleSubmit}>
      <Box mb={3} paddingX={[4, 8, 12]}>
        <StyledDropZoneContainer container justify="center">
          <DropzoneAreaBase
            fileObjects={values.imagesToVerify}
            acceptedFiles={['image/*']}
            onAdd={(newFileObjs) => {
              setFieldValue(
                'imagesToVerify',
                [].concat(values.imagesToVerify, newFileObjs as never),
              );
            }}
            onDelete={(deleteFileObj) => {
              setFieldValue(
                'imagesToVerify',
                values.imagesToVerify.filter(
                  (e: any) => e.file.name !== deleteFileObj.file.name,
                ),
              );
            }}
            getPreviewIcon={(file, classes) => {
              return (
                <ImageWrapper container>
                  <Grid item xs={2}>
                    <img src={get(AssuranceIcon, 'jpeg')} alt="jpeg" />
                  </Grid>
                  <Grid item xs={4}>
                    <StyledShortBody color="#616C78" weight="500">
                      {file.file.name}
                    </StyledShortBody>
                    <StyledCaptions>
                      {formatBytes(file.file.size)}
                    </StyledCaptions>
                  </Grid>
                </ImageWrapper>
              );
            }}
            dropzoneText={translate(get(messages, 'dropZoneText'), props)}
            showPreviewsInDropzone={false}
            showPreviews={true}
            previewText=""
            previewGridProps={{
              container: {
                spacing: 2,
                direction: 'row',
              },
              item: {
                xs: 12,
              },
            }}
            getFileAddedMessage={(fileName: string) =>
              `${fileName} ${translate(
                get(messages, 'successfullyAdded'),
                props,
              )}`
            }
            getFileRemovedMessage={(fileName: string) =>
              `${fileName} ${translate(get(messages, 'deleted'), props)}`
            }
            filesLimit={1.1}
          />
        </StyledDropZoneContainer>
      </Box>
      <ActionsButtons onClickPrevious={onClickPrevious} isLoading={isLoading} />
    </form>
  );
};

export interface FormProps {
  intl: IntlShape;
  isLoading: boolean;
  onClickPrevious: Function;
  onSubmitStep: Function;
}

interface FormValues {
  imagesToVerify: [];
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    return {
      imagesToVerify: [],
    };
  },

  handleSubmit: (values, { props }) => {
    /* istanbul ignore next */
    if (values.imagesToVerify.length > 0) {
      const valuesToSubmit = values.imagesToVerify.map(
        (value: { data: string; file: any }) => value.data,
      );
      props.onSubmitStep(valuesToSubmit[0]);
    }
  },
})(InnerForm);

export default injectIntl(Form);
